// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderHeight":"80px","tableHeaderSmallHeight":"60px","tableRowHeight":"30px","tableFilterHeight":"40px","rowCounts":"11,15,16,19,25,35,45"};